// extracted by mini-css-extract-plugin
export default {"container":"micromag-summary_container__2RP_8","form":"micromag-summary_form__1c2Ty","button":"micromag-summary_button__AMcqf"};